import { render, staticRenderFns } from "./PairedElementView.vue?vue&type=template&id=2d904129"
import script from "./PairedElementView.vue?vue&type=script&lang=js"
export * from "./PairedElementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports